import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class ReportIncomeService extends BaseService {
  getReportIncome() {
    let url = environment.portalApi + '/ReportIncome/GetReportIncome';
    return this.http.get(url, { headers: this.createHeader() });
  }
  getReportIncomeById(id: any) {
    let url = environment.portalApi + '/ReportIncome/Download?id=' + id;
    return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
  }
}